export enum QuickFilterType {
  BIG = "big",
  SMALL = "small",
}

export enum BackgroundType {
  CUSTOM = "custom",
}
